import { ApiResponseNHL, useFetchLeagueData } from '~/core/api';

import { DraftResponse } from './types';

export const useDraftQuery = (year?: string, round?: string): ApiResponseNHL<DraftResponse> =>
    useFetchLeagueData(`/draft/picks/${year}${round && year ? `/${round}` : ''}`);
